<template>
  <v-row class="i-search-sort" no-gutters>
    <v-col>
      <v-card class="card">
        <div class="search-div">
          <v-btn
            class="search-btn"
            elevation="0"
            :loading="loading"
            @click="searchImmediately"
          >
            Search
            <v-icon class="ml-2 pt-1" size="20px">mdi-filter-variant</v-icon>
          </v-btn>
          <v-text-field
            solo
            flat
            hide-details
            clearable
            dense
            autocomplete="off"
            ref="input"
            v-model="filterText"
            :disabled="loading"
            :loading="loading"
            :placeholder="filterPlaceholder"
            @input="handleInputChange"
            @click:clear="handleInputReset"
            @keyup.enter="searchImmediately"
          >
          </v-text-field>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
const DEBOUNCE_RESPONSE_TIMER = 2000
const DEBOUNCE_SEARCH_TIMER = 2000

export default {
  props: {
    filterPlaceholder: {
      type: String,
      default: 'Search'
    },
    initialFilterText: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    debounceResponse: null,
    debounceSearch: null,
    filterText: '',
    loading: false,
    searchedImmediately: false
  }),

  methods: {
    handleInputChange() {
      // Only if text exists otherwise reset triggers it again
      if (this.filterText) {
        clearTimeout(this.debounceSearch)
        this.debounceSearch = setTimeout(() => {
          if (!this.searchedImmediately) {
            this.loading = true
            this.triggerDebounceResponse()
          } else {
            this.searchedImmediately = false
          }
        }, DEBOUNCE_SEARCH_TIMER)
      }
    },

    handleInputReset() {
      this.loading = true
      this.filterText = ''
      this.triggerDebounceResponse()
    },

    searchImmediately() {
      this.searchedImmediately = true
      this.loading = true
      this.triggerDebounceResponse()
    },

    triggerDebounceResponse() {
      clearTimeout(this.debounceResponse)
      this.debounceResponse = setTimeout(() => {
        this.loading = false
        this.$emit('filter', this.filterText)
      }, DEBOUNCE_RESPONSE_TIMER)
    }
  },

  mounted() {
    this.filterText = this.initialFilterText || ''
  },

  watch: {
    initialFilterText(value) {
      this.filterText = value
    }
  }
}
</script>
